import React, { useState, useEffect } from 'react';
import { Input, Button, Alert } from '../../../atoms';
import { ListOfAvaliacaoEmocional } from '../../../organisms';
import { AvaliacaoEmocionalForm, AnswersInfo } from '../../../molecules';
import { useAccessToken } from '../../../../hooks';

const AvaliacaoEmocional = ({ token, client, updateClient }) => {

  const [alert, setAlert] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [currentEvaluation, setCurrentEvaluation] = useState(null);
  const access_token = useAccessToken(isAuthenticated, setIsAuthenticated);

  return (
    <>
      <div>
        {
          alert && <Alert text={alert.message} className={alert.type} />
        }
      </div>
      <div>
        <Button text="Novo Cadastro" className="btn-primary" onSubmit={() => setCurrentEvaluation(null)} />
        <AnswersInfo answers={client.answers} type="emocional" />
      </div>
      <div className="row mt-3">
          <div className="col-md-5">
            <ListOfAvaliacaoEmocional client={client} onSelect={setCurrentEvaluation} currentEvaluation={currentEvaluation} />
          </div>
          <div className="col-md-7">
            <AvaliacaoEmocionalForm evaluation={currentEvaluation} token={token} client={client} updateClient={updateClient} setCurrentEvaluation={setCurrentEvaluation} />
          </div>
        </div>
    </>
  );
}

export { AvaliacaoEmocional };